module.exports = __webpack_public_path__ + "static/media/2025-The-Debrief-Feature-Banner-lg@2x.add9e749.jpg";